module.exports = __webpack_public_path__ + "static/media/credentialing-vendors-invitation.75fec235.svg";